module.exports = __webpack_public_path__ + "static/media/notes.c9bb5408.png";